exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".warning[data-v-6a055708]{border:1px solid #d2d5d9;border-radius:10px;background:#faebd7;padding:20px;margin-bottom:20px}", ""]);

